/**
 * The MintUpcoming container
 */
import { ScrollToTop as useScrollToTop } from "@bkry/bowline-components/Utils";
import { listTiersForProject } from "@bkry/bowline-redux/mintTiers";
import { env } from "@bkry/bowline-utils";
import { useWeb3React } from "@web3-react/core";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import ReactPlayer from "react-player";
import { useDispatch } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import AboutSamsung from "../components/AboutSamsung";
import ArtistTabsGenesis from "../components/ArtistTabsGenesis";
import Faq from "../components/Faq";
import LedgerSection from "../components/LedgerSection";
import MX1Roadmap from "../components/MX1Roadmap";
import MintAnnouncement from "../components/MintAnnouncement";
import MintPassCard from "../components/Minting/MintPassCard";
import MintingWrapper from "../components/Minting/MintingWrapper";
import Page from "../components/Page/Page-component";
import BundleSection from "../components/PreorderBundleSection/BundleSection-component";

// import RaffleWinnerAnnouncement from "../components/RaffleWinnerAnnouncement";
const { REACT_APP_PROJECT_ID, REACT_APP_CDN_PATH } = env;
/**
 * MX1GenesisMint container, the landing page for logged in users
 */
const MX1GenesisMint = ({ mintTierId }) => {
  useScrollToTop();
  const dispatch = useDispatch();
  const { account } = useWeb3React();

  useEffect(() => {
    dispatch(
      listTiersForProject({
        projectId: REACT_APP_PROJECT_ID,
        address: account,
      })
    );
    window.scrollTo(0, 0);
  }, [dispatch, REACT_APP_PROJECT_ID, account]);

  return (
    <Page id="home" title="Samsung MX1 Genesis" className="mb-3">
      <MintingWrapper
        mintTierId={mintTierId}
        tokenTitle={"MX1 Genesis Edition"}
      >
        <Row className="gy-5 bigger-margin-bottom">
          <Col xs={12} lg={6} className="justify-content-center pe-lg-5">
            <div>
              <ReactPlayer
                url={(REACT_APP_CDN_PATH || "") + "/640x650_Mint_prev.mp4"}
                controls={true}
                playing={true}
                playsinline
                muted={true}
                loop={true}
                width="100%"
                height="auto"
              />
            </div>
          </Col>
          <Col
            className="d-flex flex-column minting-wrapper ps-lg-5"
            xs={12}
            lg={6}
          >
            {mintTierId && <MintPassCard mintTierId={mintTierId} />}
            {!mintTierId && <span>Mint Info Missing</span>}
          </Col>
        </Row>
        {/* <RaffleWinnerAnnouncement /> */}
        <MintAnnouncement roadmapSlug="mint-announcement-mx1-genesis" />
        <BundleSection />
        <ArtistTabsGenesis />
        <div
          className="about-background"
          style={{
            backgroundImage: "url('/background.png')",
          }}
        >
          <AboutSamsung />
          <LedgerSection />
        </div>
        <Row className="d-flex justify-content-end align-items-end d-lg-none">
          <Col>
            <img
              src={(REACT_APP_CDN_PATH || "") + "/background.png"}
              style={{
                maxWidth: "100%",
                transform: "scale(-1)",
              }}
            />
          </Col>
        </Row>
        <MX1Roadmap />
      </MintingWrapper>
      <Container className="bigger-margin-top bigger-margin-bottom">
        <Faq faqListSlugs={["mx1roadmap", "ledger", "minting"]} />
      </Container>
    </Page>
  );
};

/**  define proptype for the 'translation' function  */
MX1GenesisMint.contextTypes = {
  t: PropTypes.func,
};

MX1GenesisMint.propTypes = {
  mintTierId: PropTypes.string,
};

/** export the component as redux connected component */
export default MX1GenesisMint;
